module.exports = function() {
  return new Worker(__webpack_public_path__ + "1bf2f2279285fa7a012c.worker.js");
};